var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ai-block"},[_c('div',{staticClass:"ai-block-cons"},[_c('div',{staticClass:"ai-cons"},[_c('img',{staticClass:"tip-img1",attrs:{"src":require("../../../assets/images/home/img12.png"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"ai-cons-html",domProps:{"innerHTML":_vm._s(_vm.explainContent)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14c9d125","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/pageSearch/assistantIsStop.vue
// module id = null
// module chunks = 